import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Tooltip } from "antd";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCustomerDetails } from "src/api/http/account";
import { accountAtom, accountsAtom } from "src/store";

export const AccountSwitcher = () => {
  const { t } = useTranslation();
  const [accounts] = useAtom(accountsAtom);
  const [items, setItems] = useState<any>(null);
  const [accountLoading, setAccountLoading] = useState<boolean>(false);
  const [account, addAccount] = useAtom(accountAtom);

  const handleChange = (index: string) => {
    const account = accounts[+index];
    getCustomerDetails(account?.customer_id)
        .then((value) => addAccount({...account, id: value?.data?.id}))
        .catch((error) => console.log(error))
        .finally(() => setAccountLoading(false));
  };
 

  useEffect(() => {
    if (accounts) {
      addAccount(accounts[0]);
      setItems(getItems(accounts || []));
    }
  }, [accounts]);

  return (
    <>
      {accounts?.length > 1 && (
        <Dropdown.Button
          menu={{ items, onClick: (info) => handleChange(info.key) }}
          placement="bottom"
          trigger={["click", "contextMenu"]}
          className="text-white"
          icon={<DownOutlined />}
          loading={accountLoading}
          disabled={accountLoading}
        >
          <Tooltip
            title={account ? account?.customer_name : t("accounts")}
            key="leftButton"
          >
            <h3 className="truncate w-32">
              {account ? account?.customer_name : t("accounts")}
            </h3>
          </Tooltip>
          
        </Dropdown.Button>
      )}
    </>
  );
};

const getItems = (items: any[]) => {
  return items?.map((item, index) => {
    return {
      key: index.toString(),
      label: item?.customer_name,
    };
  });
};
